import { Backdrop, Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import http from "../../utils/http";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { errorToastMessage } from "../../utils/toast";
import {
  setPlatformPermissions,
  setRoleId,
} from "../../Redux/reducers/userSlice";
import Loader from "../Common/assets/Loader";
import AiSearch from "./AiSearch/AiSearch";
import UserProfileCard from "./UserProfileCard";
// import "../../utils/firebaseInit";

const Header = () => {
  const location = useLocation();
  const isParticipantsRoute = location.pathname === "/app/participants";

  return (
    <Box
      sx={{
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: "0px 24px",
        bgcolor: "#FFFFFF",
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      <Box sx={{ ml: "auto", display: "flex", gap: 2 }}>
        {isParticipantsRoute && <AiSearch />}
        <UserProfileCard collapsed={true} />
      </Box>
    </Box>
  );
};

const AppLayout = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const toggleLoader = useAppSelector((state) => state.user.toggleLoader);

  useEffect(() => {
    const fetchPlatformRights = async () => {
      try {
        setLoading(true);

        const res: AxiosResponse = await http.get(`platform/roles/self-rights`);
        const data = res?.data?.data;
        const { permissions, roleId } = data;
        dispatch(setPlatformPermissions(permissions));
        dispatch(setRoleId(roleId || ""));
      } catch (e) {
        errorToastMessage(e as Error);
      } finally {
        setLoading(false);
      }
    };
    fetchPlatformRights();
  }, [dispatch, toggleLoader]);

  useEffect(() => {
    return () => {
      dispatch(setPlatformPermissions([]));
    };
  }, [dispatch]);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        "& .svgicon.stroke": {
          stroke: (theme) => theme.palette.text.secondary,
        },
        "& .svgicon.fill": {
          fill: (theme) => theme.palette.text.secondary,
        },
        "& .svgicon-primary.fill": {
          fill: (theme) => theme.palette.primary.main,
        },
        "& .svgicon-primary.stroke": {
          stroke: (theme) => theme.palette.primary.main,
        },
        "& .svgicon-tprimary.stroke": {
          stroke: (theme) => theme.palette.text.primary,
        },
        "& .svgicon-tprimary.fill": {
          fill: (theme) => theme.palette.text.primary,
        },
      }}
    >
      <Sidebar />
      <Box
        sx={{
          flex: 1,
          minWidth: "1px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading && (
          <Backdrop
            open={true}
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          >
            <Loader />
          </Backdrop>
        )}
        <Header />
        <Box
          sx={{
            flex: 1,
            minHeight: "1px",
            backgroundColor: "#F4F5F7",
          }}
        >
          {!loading && <Outlet />}
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;
